// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"a3d0a886","143":"35d7c13b","265":"6bb74577","485":"9a69d584","709":"1e7480b9","754":"a849eafa","787":"544ce7aa","821":"91e470e7"}[chunkId] + ".chunk.js";
};